/* global google:false */
/* global isotope:false */
/* global PhotoSwipe:false */
/* global PhotoSwipeUI_Default:false */
function resizeImages() {

    var firstSlideshow = $( ".first-slideshow" );
    if (firstSlideshow.length > 0) {
        if (window.innerWidth < window.innerHeight) {
            firstSlideshow.addClass("fsh-fix").removeClass("fsw-fix");
        } else {
            firstSlideshow.addClass("fsw-fix").removeClass("fsh-fix");
        }
    }

}

$( document ).ready( function() {

    "use strict";

    var readMoreToggle = $(".read-more-toggle");
    if (readMoreToggle.length > 0) {
        readMoreToggle.each(function() {
            $(this).readMoreToggler();
        });
    }

    $('.post-navigation .nav-link').hover(function() {
        var bg = $(this).data('arrow');
        var titles = $(this).children('.nav-list-label');

        $('.post-navigation').addClass('post-navigation--hover');
        titles.toggleClass('visible invisible');
        $('.hover-bg[data-bg='+bg+']').stop().css('opacity', '1');
    }, function() {
        var bg = $(this).data('arrow');
        var titles = $(this).children('.nav-list-label');
        $('.post-navigation').removeClass('post-navigation--hover');
        titles.toggleClass('visible invisible');
        $('.hover-bg[data-bg='+bg+']').stop().css('opacity', '0');
    });

    $('.flickity-button, .dot').click(function (e) {
        e.preventDefault();
    });

    $('.floorplan__icon>a').click(function (e) {
        e.preventDefault();
        var link =  $(this).attr('href');
        $('.modal-body--img').attr('src', link);
        $('#room-modal').modal('show');
    });

    $('.home-slide-item').click(function(e) {
        e.preventDefault();
        var slide = $(this).data('slide');
        // $('.home-room-wrapper-img').slick('slickGoTo', slide);
        window.location.href = slide;
    });

    var navPos = $('.header').position().top;
    var lastPos = 0;
    $(window).on('scroll', function () {

        var pos = $(window).scrollTop();

        if (pos >= navPos + $('.header').height() && lastPos < pos) {
            $('.header').addClass('fixed');
        }
        if (pos === 0) {
            $('.header').removeClass('fixed');
        }
        lastPos = pos;
    });


    $("#navbarNavDropdown").on("transitionend", function(){
        $('.navbar-toggler-icon').stop().toggleClass('navbar-toggler-icon--close');
    });

    /**
     * Webhotelier Form
     */
    var $webhotelierForm = $('#webhotelier-form');
    if ($webhotelierForm.length > 0 ) {
        var elWebhotelierForm = $webhotelierForm;
        elWebhotelierForm.webhotelierForm( elWebhotelierForm.data( 'json' ) );
    }

    /**
     * Backgrounds Images
     */
    var bgImageElements = $("*[data-bg-image-url]");
    if (bgImageElements.length > 0) {
        bgImageElements.each(function() {
            var bgImageElement = $(this);

            if ( $(this).attr('id') !== 'home-welcome-wrapper' || window.innerWidth > 992 ) {
                var bgImageElementUrl = bgImageElement.attr("data-bg-image-url");
                if (bgImageElementUrl.length > 0) {
                    bgImageElement.css("background-image", "url(" + bgImageElementUrl +")");
                }
            }



        });
    }

    /**
     * Slick Slider
     */
    var slickEl = $("*[data-slick]");
    if (slickEl.length > 0) {
        slickEl.each(function() {

            var slickElement = $(this);

    //         slickElement.slickSlider();
            slickElement.slick();

        });

    }

    /**
     * Photo Swipe Slider
     */
    var photoSwipeSlider = $("*[data-photoswipe-options]");
    if (photoSwipeSlider.length > 0) {
        photoSwipeSlider.each(function() {
            var el = $(this);
            el.photoswipeLightbox(el.data("photoswipe-options"));
        });
    }


    /**
     * Masonry Gallery
     */
    var gallery = $(".masonry-gallery");
    var filterLinkGroup = $('.masonry-gallery-filters');
    var isIsotopeInit = false;

    function getHashFilter() {
        var matches = location.hash.match( /filter=([^&]+)/i );
        var hashFilter = matches && matches[1];
        return hashFilter && decodeURIComponent( hashFilter );
    }

    function onHashchange() {
        var hashFilter = getHashFilter();
        if ( !hashFilter && isIsotopeInit ) {
            return;
        }
        isIsotopeInit = true;
        /**
         * init Isotope after all images have loaded
         */
        gallery.imagesLoaded().progress( function() {
            gallery.isotope({
                filter: hashFilter
            });
            gallery.isotope('layout');
        });

        if ( hashFilter ) {
            filterLinkGroup.find('.active').removeClass('active');
            filterLinkGroup.find('[data-filter="' + hashFilter + '"]').addClass('active');
        }
    }

    if (gallery.length > 0) {
        /**
         * Filter items on button click
         */
        $(".masonry-gallery-filters").on("click", "li a", function() {
            var filterAttr = $( this ).attr('data-filter');
            location.hash = 'filter=' + encodeURIComponent( filterAttr );
        });

        onHashchange();

        /**
         * Lightbox
         */
        gallery.photoswipeLightbox(gallery.data("photoswipe-options"));
    }
    $(window).on( 'hashchange', onHashchange );

    /**
     * Awards slider
     */
    $('#awards-slider').slick({
        dots: true,
        infinite: true,
        speed: 300,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                }
            },
        ]
    });

});

$(function() {

    "use strict";

    $(window).resize(function() {

    });

    $(window).on('resize orientationchange', function() {

    });

    $(window).scroll(function() {

    });

});

(function($) {

    "use strict";

    /**
     * Webhotelier Form Functon
     *
     * @param options
     */
    $.fn.webhotelierForm = function(options) {
        var el = $(this);

        var settings = $.extend({
            "split_dates": el.data("split_dates"),
            "icon_date": el.data("icon_date"),
        }, options);

        function getField(id) {
            var fieldEl = $("#" + id + "-picker");
            return fieldEl.length ? fieldEl : null;
        }

        function pickerSetup(id, date) {
            var el = getField(id);

            if (el !== null) {
                var checkin = (id === "checkin");

                el.datepicker({
                    altField: el.get(0).form[id],
                    altFormat: "yy-mm-dd",
                    numberOfMonths: 2,
                    defaultDate: "+0",
                    changeMonth: true,
                    changeYear: true,
                    dateFormat: "dd/M/y",
                    mandatory: true,
                    showButtonPanel: true,
                    firstDay: 1,
                    minDate: checkin ? 0 : 1,
                    maxDate: "+2y",
                    showAnim: 'slideDown',
                    showOn: settings.icon_date ? "button" : "focus",
                    buttonImage: settings.icon_date ? settings.icon_date : "",
                    buttonImageOnly: settings.icon_date ? "true" : "false",
                    buttonText: "Select date",

                    onSelect: function (dateText, inst) {

                        if (checkin && getField("checkout") !== null) {

                            // Change minimum date of checkout field to checkin + 1
                            var constraint = new Date(el.datepicker("getDate"));
                            constraint.setDate(constraint.getDate() + 1);
                            getField("checkout").datepicker("option", "minDate", constraint);

                            if (settings.split_dates) {
                                // update visible Fields
                                var d = $.datepicker.parseDate(inst.settings.dateFormat, dateText);
                                $("." + id + "-date-day").text($.datepicker.formatDate("dd", d));
                                $("." + id + "-date-month").text($.datepicker.formatDate("M", d));
                                $("." + id + "-date-year").text($.datepicker.formatDate("y", d));

                                $(".checkout-date-day").text($.datepicker.formatDate("dd", constraint));
                                $(".checkout-date-month").text($.datepicker.formatDate("M", constraint));
                                $(".checkout-date-year").text($.datepicker.formatDate("y", constraint));
                            }
                        }
                        if (settings.split_dates) {
                            if (id === "checkout") {
                                // update visible Fields
                                var t = $.datepicker.parseDate(inst.settings.dateFormat, dateText);
                                $("." + id + "-date-day").text($.datepicker.formatDate("dd", t));
                                $("." + id + "-date-month").text($.datepicker.formatDate("M", t));
                                $("." + id + "-date-year").text($.datepicker.formatDate("y", t));

                            }
                        }
                    },

                    onClose: function (selectedDate) {
                        // Set next day date to checkout field
                        if (selectedDate) {
                            var nextDay = $.datepicker.parseDate("dd/M/y", selectedDate );
                            nextDay.setDate(nextDay.getDate() + 1);
                            getField("checkout").datepicker("option", "minDate", nextDay );
                        }
                        // Fill out nights input
                        var nightsEl = $("input[name='nights']");
                        if (nightsEl.length > 1 && getField("checkout") !== null) {
                            var datesDiff = Math.abs($("input[name='checkout']").val().getTime() - $("input[name='checkin']").val().getTime());
                            var nights = Math.ceil(datesDiff / (1000 * 3600 * 24) );
                            nightsEl.val(nights);
                        }

                    }

                });

                el.datepicker("setDate", date);

            }

            if (settings.split_dates) {
                $("." + id + "-date").on("click", function () {
                    $("#" + id + "-picker").datepicker("show");
                });
            }

        }

        pickerSetup("checkin", "+0");
        pickerSetup("checkout", "+1");

    };

    /**
     * Google Map Function
     */
    $.fn.googleMap = function(options) {
        var el = $(this);

        var settings = $.extend({
            "lat": "37.979561",
            "lng": "23.728487",
            "zoom": 13,
            "styles": "",
            "places_categories": false,
            "locations": [{
                lat: -33.890542,
                lng: 151.274856,
                address: "",
                tooltip: false,
                marker_svg: false,
                marker_svg_file: false,
                image_src: "",
                image_alt: "",
                info_title: "",
                info_text: "",
                info_btn: "",
                info_btn_url: "",
                info_btn_target: "",
            }],
        }, options);

        var markers = [];
        var bounds = new google.maps.LatLngBounds();
        var directionsDisplayOptions = {
            suppressMarkers: true
        };
        var directionsService = new google.maps.DirectionsService;
        var directionsDisplay = new google.maps.DirectionsRenderer;
        directionsDisplay.setOptions( directionsDisplayOptions );

        // var offsetHeight = $("nav.navbar").position();
        var offsetHeight = $("nav.navbar").height() * 2;

        var map = new google.maps.Map(el[0], {
            zoom: settings.zoom,
            zoomControl: true,
            scaleControl: false,
            scrollwheel: false,
            styles: settings.styles ? settings.styles : "",
            streetViewControl: false,
            disableDoubleClickZoom: true,
            mapTypeControl: false,
            fullscreenControl: false
        });

        $.each(settings.locations, function (i, attr) {

            var locLatLng = new google.maps.LatLng(attr.lat, attr.lng);
            var infoButtonString = "";
            var infoImageUrl = "";
            var markerInfowindow = false;
            var icon = false;

            if (attr.info_btn_url) {
                infoButtonString = "<p><a href=\"" + attr.info_btn_url + "\" target=\"" + attr.info_btn_target + "\">" + attr.info_btn + "</a></p>";
            }

            if (attr.image_src) {
                infoImageUrl = "<div class=\"side-gmap\"><img src=\"" + attr.image_src + "\" alt=\"" + attr.image_alt + "\" /></div>";
            }

            if (attr.marker_svg_file) {
                icon = {
                    url: attr.marker_svg_file,
                    anchor: new google.maps.Point(20, 80),
                    scaledSize: new google.maps.Size(40, 80),
                };
            }

            if (attr.info_text || attr.info_title) {
                var contentString =
                    "<div class=\"map-infowindow\">" +
                    infoImageUrl +
                    "<div class=\"main-gmap\">" +
                    "<h3 class=\"text-dark\">" + attr.info_title + "</h3>" +
                    "<div class=\"text-dark\">" + attr.info_text +
                    infoButtonString +
                    "</div>" +
                    "</div>" +
                    "</div>";

                markerInfowindow = new google.maps.InfoWindow({
                    content: contentString
                });
            }

            var marker = new google.maps.Marker({
                position: locLatLng,
                map: map,
                icon: icon ? icon : "",
                draggable: false,
                zIndex: -20,
                infowindow: markerInfowindow ? markerInfowindow : false,
            });

            markers.push(marker);

            marker.addListener("click", function () {
                hideAllInfoWindows(map);
                if (this.infowindow) {
                    this.infowindow.open(map, this);
                }
                map.setCenter(this.getPosition());
                map.panTo(this.getPosition());

                if (offsetHeight) {
                    map.panBy(0, -offsetHeight);
                }
            });

            map.panTo(marker.getPosition());

            // if (offsetHeight && window.innerWidth > 768) {
            //     map.panBy(0, -offsetHeight);
            // }

            bounds.extend(locLatLng);

            if (attr.routes) {
                if (Object.keys(attr.routes).length > 1) {
                    if ($("#collapse-location-routes.collapse").length > 0 && $(window).height() > 767) {
                        $("#collapse-location-routes.collapse").collapse();
                    }

                    $("#location-routes .list-group-item-action").on("click", function (e) {
                        e.preventDefault();
                        $("#location-place-categories").find(".list-group-item-action.active").removeClass("active");
                        var elId = $(this).attr("id");
                        $.each(attr.routes, function (k, routeAttr) {
                            if (elId === routeAttr.title.toLowerCase()) {
                                clearMarkers();
                                var routeLocLatLng = new google.maps.LatLng(routeAttr.lat, routeAttr.lng);
                                calculateAndDisplayRoute(directionsService, directionsDisplay, locLatLng, routeLocLatLng);
                            }
                        });
                    });
                }
            }
        });

        if (settings.places_categories) {
            var placeMarkers = [];

            $("#location-place-categories .list-group-item-action").on("click", function (e) {
                e.preventDefault();
                $("#location-routes").find(".list-group-item-action.active").removeClass("active");

                if ($(this).find(".place-category-icon")) {
                    var markerColor = $(this).find(".place-category-icon").css("background-color");
                }

                // Clear directions if any
                directionsDisplay.setMap(null);
                clearMarkers();

                var elId = $(this).attr("id");

                $.each(settings.places_categories, function (title, placesCategory) {
                    if (elId === placesCategory.title) {
                        $.each(placesCategory.places, function (title, place) {

                            var placeMarkerInfowindow = false;
                            var placeIcon = {
                                // anchor: new google.maps.Point(0, 0),
                                strokeColor: markerColor,
                                path: "M75.85 68.35L42.5 110 9.15 68.35A41.83 41.83 0 0 1 0 42.21C0 18.94 19.06 0 42.5 0S85 18.93 85 42.2c0 9.87-3.42 18.95-9.15 26.14zM42.5 22.65c-10.55 0-19.13 8.52-19.13 19s8.58 19 19.13 19 19.13-8.52 19.13-19-8.58-19-19.13-19zm0 7.6",
                                fillColor: markerColor,
                                fillOpacity: 1,
                                // scaledSize: new google.maps.Size(1, 1),
                                scale: 0.5,
                                // strokeWeight: 0,
                                // rotation: 0
                            };

                            if (placesCategory.marker_svg_file) {
                                placeIcon = {
                                    url: placesCategory.marker_svg_file,
                                    // anchor: new google.maps.Point(0, 0),
                                    strokeColor: markerColor,
                                    fillColor: markerColor,
                                    fillOpacity: 1,
                                    // scaledSize: new google.maps.Size(8, 8),
                                    scale: 1,
                                    // strokeWeight: 0,
                                    // rotation: 0
                                };
                            }

                            if (place.title || place.description) {
                                var placeContentString = "<div>";

                                if (place.title) {
                                    placeContentString = placeContentString + "<h5 class=\"\">" + place.title + "</h5>";
                                }
                                if (place.description) {
                                    placeContentString = placeContentString + "<p class=\"mb-0\">" + place.description + "</p>";
                                }
                                placeContentString = placeContentString + "</div>";

                                placeMarkerInfowindow = new google.maps.InfoWindow({
                                    content: placeContentString
                                });
                            }

                            var placeLocLatLng = new google.maps.LatLng(place.lat, place.lng);

                            var placeMarker = new google.maps.Marker({
                                position: placeLocLatLng,
                                map: map,
                                draggable: false,
                                icon: placeIcon ? placeIcon : "",
                                zIndex: -20,
                                infowindow: placeMarkerInfowindow ? placeMarkerInfowindow : false,
                            });

                            placeMarkers.push(placeMarker);
                            bounds.extend(placeLocLatLng);
                            map.fitBounds(bounds);
                            map.setCenter(bounds.getCenter());
                            map.setZoom(map.getZoom()-1);
                            map.panTo(bounds.getCenter());
                            if (offsetHeight) {
                                map.panBy(0, -offsetHeight);
                            }
                            // if (Object.keys(settings.locations).length > 1) {
                            //     map.fitBounds(bounds);
                            // }
                            // else if (Object.keys(settings.locations).length === 1) {
                            //     map.setZoom(settings.zoom-1);
                            // }

                            placeMarker.addListener("click", function () {
                                hideAllPlacesInfoWindows(map, placeMarkers);
                                if (this.infowindow) {
                                    this.infowindow.open(map, this);
                                }
                                map.setCenter(this.getPosition());
                                map.panTo(this.getPosition());

                                if (offsetHeight) {
                                    map.panBy(0, -offsetHeight);
                                }
                            });
                        });
                    }
                });
            });
        }

        if (Object.keys(settings.locations).length > 1) {
            map.fitBounds(bounds);
        }
        else if (Object.keys(settings.locations).length === 1) {
            map.setZoom(settings.zoom);
        }

        function hideAllInfoWindows(map) {
            markers.forEach(function (marker) {
                if (marker.infowindow) {
                    marker.infowindow.close(map, marker);
                }
            });
        }

        function calculateAndDisplayRoute(directionsService, directionsDisplay, start, end) {
            directionsService.route({
                origin: start,
                destination: end,
                travelMode: "DRIVING"
            }, function(response, status) {
                if (status === "OK") {
                    directionsDisplay.setDirections(response);
                    directionsDisplay.setMap(map);
                    // if (offsetHeight) {
                    //     map.panBy(500, +offsetHeight);
                    // }
                    map.setCenter(this.locLatLng);
                } else {
                    window.alert("Directions request failed due to " + status);
                }
            });
        }

        function hideAllPlacesInfoWindows(map, placeMarkers) {
            placeMarkers.forEach(function (placeMarker) {
                if (placeMarker.infowindow) {
                    placeMarker.infowindow.close(map, placeMarker);
                }
            });
        }

        // Removes the markers from the map, but keeps them in the array.
        function clearMarkers() {
            setMapOnAll(null);
        }

        // Sets the map on all markers in the array.
        function setMapOnAll(map) {
            for (var i = 0; i < placeMarkers.length; i++) {
                placeMarkers[i].setMap(map);
            }
        }
    };

    /**
     * Read More Toggler
     */
    $.fn.readMoreToggler = function() {
        var readMoreToggle = $(this),
            entryContent = $(this).parent().find(".entry-content, .room-features"),
            readMoreToggleLink = readMoreToggle.find(".read-more-toggle-link"),
            entryContentHeight = entryContent.height(),
            entryContentMaxHeight = readMoreToggleLink.attr("data-max-height");

        if ( entryContentHeight > entryContentMaxHeight ) {
            entryContent.css("max-height", entryContentMaxHeight + "px" ).addClass("faded");
            readMoreToggle.removeClass("d-none");
            readMoreToggleLink.on("click", function(e) {
                e.preventDefault();
                $(this).toggleClass("toggled");
                if ($(this).hasClass("toggled")) {
                    $(this).html($(this).attr("data-close-text"));
                }
                else {
                    $(this).html($(this).attr("data-open-text"));
                }
                entryContent.toggleClass("toggled");
            });
        }
    };

    /**
     * Photoswipe Lightbox
     *
     * @param options
     */
    $.fn.photoswipeLightbox = function(options) {
        var el = $(this);

        var settings = $.extend({
            closeOnScroll: true,
            escKey: true,
            arrowKeys: true,
            loop: true,
            history: true,
            focus: true,
            modal: true,
            showHideOpacity: true,
            closeEl: true,
            captionEl: true,
            fullscreenEl: true,
            zoomEl: true,
            shareEl: true,
            counterEl: true,
            arrowEl: true,
            preloaderEl: true,
        }, options);

        el.each( function() {
            var $pic     = $(this),
                getItems = function() {
                    var items = [];
                    $pic.find("a").each(function() {

						var item = {
							src : $(this).data("src"),
							w   : $(this).data("width"),
							h   : $(this).data("height"),
							msrc   : $(this).find("img").attr("src"),
							title   : $(this).data("title"),
							pid   : $(this).data("slug"),
						};

                        items.push(item);
                    });
                    return items;
                };

            var items = getItems();

            var $pswp = $(".pswp")[0];
            $pic.on("click", "a", function(event) {
                event.preventDefault();

                var $index = $(this).data("index");
                var options = {
                    index: $index,
                    bgOpacity: 0.7,
                    spacing: 0.12,
                    allowPanToNext: true,
                    pinchToClose: true,
                    closeOnScroll: settings.closeOnScroll,
                    closeOnVerticalDrag: true,
                    escKey: settings.escKey,
                    arrowKeys: settings.arrowKeys,
                    history: settings.history,
                    mouseUsed: false,
                    loop: settings.loop,
                    focus: settings.focus,
                    modal: settings.modal,
                    showHideOpacity: settings.showHideOpacity,
                    showAnimationDuration: 333,
                    hideAnimationDuration: 333,
                    closeEl: settings.closeEl,
                    captionEl: settings.captionEl,
                    fullscreenEl: settings.fullscreenEl,
                    zoomEl:  settings.zoomEl,
                    shareEl:  settings.shareEl,
                    counterEl: settings.counterEl,
                    arrowEl: settings.arrowEl,
                    preloaderEl:  settings.preloaderEl,
                };

                // Initialize PhotoSwipe
                var lightBox = new PhotoSwipe($pswp, PhotoSwipeUI_Default, items, options);
                lightBox.init();
            });
        });
    };


	let clock = document.querySelector('#local-time');

	let renderTime = function () {
		let time = new Date();
		clock.textContent = time.toLocaleString('en-US', {hour: 'numeric', minute: 'numeric', hour12: false});
	};

	setInterval(renderTime, 1000);

})(jQuery);
